import { EnvelopeIcon, GlobeAltIcon, LinkIcon } from '@heroicons/react/24/outline';

import React from 'react';

type TeamMember = {
	name: string;
	role: string;
	bio: string;
	image: string;
	socials: {
		website?: string;
		linkedin?: string;
		email?: string;
	};
};

const members: TeamMember[] = [
	{
		name: 'Francis Cobbinah Antobre',
		role: 'Executive Director',
		bio: 'Leads the organization with a vision to empower Black communities through strategic initiatives and partnerships.',
		image: '/assets/team-member-1.jpg',
		socials: {
			
			linkedin: 'https://ca.linkedin.com/in/francisantobre',
			email: 'mailto:president@pbcnetwork.ca'
		}
	},
	{
		name: 'Robberta Ehiagetor',
		role: 'Director of Administration',
		bio: 'Directs administrative operations and ensures organizational efficiency.',
		image: '/assets/team-member-2.jpg',
		socials: {
			
			linkedin: 'https://ca.linkedin.com/in/roberta-ehigiator-ba-scmp-in-progress-283a294b?trk=people-guest_people_search-card',
			email: 'mailto:vicepresident@pbcnetwork.ca'
		}
	},
	{
		name: 'Bridgette Esi Krampa',
		role: 'Director of Finance & Compliance',
		bio: 'Leads Finance and Compliance to ensure organizational integrity and sustainability.',
		image: '/assets/team-member-3.jpg',
		socials: {
			
			linkedin: 'https://ca.linkedin.com/in/bridgette-krampa-37710931',
			email: 'mailto:finance@pbcnetwork.ca'
		}
	},
	{
		name: 'Vera Hanson',
		role: 'Director of Communications & Media Relations',
		bio: 'Builds strategic partnerships that connect communities, allies, and opportunities.',
		image: '/team-member-4.jpg',
		socials: {
			
			linkedin: '#',
			email: 'mailto:secretary@pbcnetwork.ca'
		}
	},
	// {
	// 	name: 'Jennifer Obeng',
	// 	role: 'Director of Operations & Events',
	// 	bio: 'Oversees operations and event planning to ensure impactful community engagement.',
	// 	image: '/assets/3pbcn.jpg',
	// 	socials: {
	// 		
	// 		linkedin: '#',
	// 		email: 'mailto:jennifer.obeng@example.org'
	// 	}
	// }
];

const SocialLink: React.FC<{ href?: string; label: string; children: React.ReactNode }> = ({ href = '#', label, children }) => (
	<a
		href={href}
		target="_blank"
		rel="noopener noreferrer"
		className="inline-flex items-center p-2 text-gray-600 transition-colors duration-200 rounded-full hover:text-primary-700 hover:bg-primary-50"
		aria-label={label}
	>
		{children}
	</a>
);

const Team: React.FC = () => {
	return (
		<div className="min-h-screen pt-20">
			{/* Hero */}
			<section className="py-16 text-white bg-gradient-to-r from-primary-800 to-primary-900">
				<div className="px-4 mx-auto text-center max-w-7xl sm:px-6 lg:px-8">
					<h1 className="mb-4 text-4xl font-bold md:text-5xl font-heading">Our Team</h1>
					<p className="max-w-3xl mx-auto text-lg text-gray-200 md:text-xl">
						Meet the leaders and builders behind our mission to empower Black communities across Canada.
					</p>
				</div>
			</section>

			{/* Team Grid */}
			<section className="py-16">
				<div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
					<div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
						{members.map((m) => (
							<div key={m.name} className="p-8 bg-white border border-gray-100 shadow-lg rounded-xl">
								<div className="flex flex-col items-center text-center">
									<div className="w-32 h-32 mb-4 overflow-hidden border-4 rounded-full shadow-md border-white/70">
										<img src={m.image} alt={m.name} className="object-cover w-full h-full" />
									</div>
									<h3 className="text-xl font-semibold text-gray-900">{m.name}</h3>
									<p className="mb-3 text-primary-700">{m.role}</p>
									<p className="mb-4 leading-relaxed text-gray-600">{m.bio}</p>
									<div className="flex items-center gap-2">
										{m.socials.website && (
											<SocialLink href={m.socials.website} label={`${m.name} website`}>
												<GlobeAltIcon className="w-5 h-5" />
											</SocialLink>
										)}
										{m.socials.linkedin && (
											<SocialLink href={m.socials.linkedin} label={`${m.name} LinkedIn`}>
												<LinkIcon className="w-5 h-5" />
											</SocialLink>
										)}
										{m.socials.email && (
											<SocialLink href={m.socials.email} label={`Email ${m.name}`}>
												<EnvelopeIcon className="w-5 h-5" />
											</SocialLink>
										)}
									</div>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>
		</div>
	);
};

export default Team;

